import type { VariantProps } from "class-variance-authority";
import { cva } from "class-variance-authority";
import { cn } from "../../utils/cn";

const variants = cva("", {
  variants: {
    orientation: {
      horizontal: "h-0 w-full my-3",
      vertical: "h-full w-0 border-l border-t-0 mx-3",
    },
  },
  defaultVariants: {
    orientation: "horizontal",
  },
});

export interface DividerProps extends VariantProps<typeof variants> {
  className?: string;
}

export function Divider({ className, orientation }: DividerProps) {
  return <hr className={cn(variants({ orientation }), className)} />;
}
